const sessionStoragePrefix = 'spm'

const keys = [
  'filled-form',
]

export const ConfigSessionStorage = Object.fromEntries(keys.map((key) => [key, `${sessionStoragePrefix}-${key}`]))

export const setSessionStorageKey = (key, value) => {
  window.sessionStorage.setItem(ConfigSessionStorage[key], value)
}

export const getSessionStorageKey = (key) => window.sessionStorage.getItem(ConfigSessionStorage[key])

export const removeSessionStorageKey = (key) => {
  window.sessionStorage.removeItem(ConfigSessionStorage[key])
}
